import { all } from 'redux-saga/effects'
import users from './users/sagas'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import tickets from './tickets/sagas'
import desks from './desks/sagas'

export default function* rootSaga() {
  yield all([user(), menu(), settings(), tickets(), users(), desks()])
}
